module.exports = __webpack_public_path__ + "img/l_zuji_off.8ca883b9.png";